//imports
import { all } from 'redux-saga/effects';

//Views
import createEditKeyFobSagas from 'Modules/keysFobs/.components/createEditKeyFob/redux/saga';
import deleteKeyFobSagas from 'Modules/keysFobs/.components/deleteKeyFob/redux/saga';
import bulkDriverIdTagsSagas from 'Modules/keysFobs/.components/bulkAddDriverIdTags/redux/saga';
import moveToAnotherAccountSagas from 'Modules/keysFobs/.components/moveToAnotherAccount/redux/saga';
import unassignDriversSagas from 'Modules/keysFobs/.components/unassignDrivers/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        createEditKeyFobSagas(),
        deleteKeyFobSagas(),
        bulkDriverIdTagsSagas(),
        moveToAnotherAccountSagas(),
        unassignDriversSagas()
    ]);
}